const API_BASE_URL = "https://server.tomorrowtoday.com";
// const API_BASE_URL = "http://127.0.0.1:5001";
export { API_BASE_URL };
